<template>
  <ModalBase>
    <template slot="header" >
      <span class="modal-base__title" v-if="!showWarning">
        {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.title") }}
      </span>
      <button
        @click="$emit('close')"
        class="modal-base__close"
      >
        X
      </button>
    </template>
    <br>
    <template slot="body" v-if="!showWarning">
      <div class="modal-body">
        {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.body") }}
      </div>
      <div class="modal-footer">
         <button
           type="button"
           class="btn btn-secondary"
           data-dismiss="modal"
           @click="deleteArtwork"
         >
           {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.confirm") }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$emit('close')"
        >
          {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.dismiss") }}
        </button>
      </div>
    </template>
    <template slot="body" v-if="showWarning">
      <div class="modal-body">
        <h2 class="error-message">
          {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.warning") }}
        </h2>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$emit('close')"
        >
          {{ I18n.t("employees.auctions_catalogs.artwork_deletion_modal.confirm_warning") }}
        </button>
      </div>
    </template>
  </ModalBase>
</template>

<script>
  import ModalBase from '@/shared/components/modal_base';

  export default {
    name: 'DeletionModal',
    components: { ModalBase },
    props: {
      artwork: Object,
      auctionsCatalog: Object,
      destroyArtwork: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        showWarning: false,
      };
    },
    methods: {
      deleteArtwork() {
        this.destroyArtwork(
          [this.auctionsCatalog.id, this.artwork.id],
        ).then(() => {
          this.$emit('close');
        }).catch(() => {
          this.showWarning = true;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/artworks/deletion_modal.vue?f4b62c96